import React, { useLayoutEffect } from 'react';

import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { Form } from 'reactstrap';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';

import SelectionableTable from '../../../common/forms/table/SelectionableTable';

import FormFooter from '../../../common/forms/FormFooter';
import Alert from '../../../common/informative/Alert';
import {
  clearTicketCorporateInvoices,
  getTicketCorporateInvoicesByCompanyId,
} from '../../../../actions/corporate/TicketCorporateCredit';
import { CARGO_CORPORATE_CREDIT_UNIFY_INVOICES_COLUMNS } from '../../../../config/columns';

const TicketCorporateCreditUnifyInvoicesForm = ({
  handleSubmit,
  loadingInvoices,
  ticketCorporateInvoices,
  dispatchGetTicketCorporateInvoices,
  dispatchClearTicketCorporateInvoices,
  companyId,
}) => {
  useLayoutEffect(() => {
    dispatchGetTicketCorporateInvoices({ companyId });

    return () => {
      dispatchClearTicketCorporateInvoices();
    };
  }, []);

  return ticketCorporateInvoices.isEmpty() ? (
    <Alert
      message="No existen tickets pendientes para esta empresa"
      type="info"
    />
  ) : (
    <Form onSubmit={handleSubmit}>
      <h5>Seleccione los boletos que desea unificar</h5>

      <SelectionableTable
        name="ticketIds"
        columns={CARGO_CORPORATE_CREDIT_UNIFY_INVOICES_COLUMNS}
        data={ticketCorporateInvoices.toJS()}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        returnOnlySelectedItems
        keyField="id"
        loading={loadingInvoices}
        form="TicketCorporateCreditUnifyInvoicesForm"
      />

      <FormFooter />
    </Form>
  );
};

TicketCorporateCreditUnifyInvoicesForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,

  loadingInvoices: PropTypes.bool,

  ticketCorporateInvoices: PropTypes.instanceOf(Immutable.Set),

  dispatchGetTicketCorporateInvoices: PropTypes.func.isRequired,

  dispatchClearTicketCorporateInvoices: PropTypes.func.isRequired,

  companyId: PropTypes.number.isRequired,
};

TicketCorporateCreditUnifyInvoicesForm.defaultProps = {
  ticketCorporateInvoices: Immutable.Set(),
  loadingInvoices: false,
};

const mapStateToProps = ({ CorporateUnit }) => ({
  ticketCorporateInvoices: CorporateUnit.TicketCorporateCredit.getIn([
    'current',
    'invoices',
  ]),

  loadingInvoices: CorporateUnit.TicketCorporateCredit.getIn([
    'current',
    'loadingInvoices',
  ]),
});

const mapDispatchToProps = {
  dispatchGetTicketCorporateInvoices: getTicketCorporateInvoicesByCompanyId,
  dispatchClearTicketCorporateInvoices: clearTicketCorporateInvoices,
};

const formComponent = reduxForm({
  form: 'TicketCorporateCreditUnifyInvoicesForm',
})(TicketCorporateCreditUnifyInvoicesForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
